import { render } from "./HeroiconsOutlineHome.vue?vue&type=template&id=10624ae9"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineHome.vue"]])

export default __exports__